export enum SalesStepTypeEnum {
  ORDER_DETAILS = 0,
  IMAGE_UPLOAD = 1,
  LOCATION_DELIVERY = 2,
  PACKING = 3,
}

export enum PurchaseStepTypeEnum {
  ORDER_DETAILS = 0,
  LOCATION_DELIVERY = 1,
}

export enum ContractStepTypeEnum {
  CONTRACT_DETAILS = 0,
  MERCHANDISE = 1,
  TRANSPORT = 2,
  DEVIATIONS = 3,
  PAYMENT = 4,
  ATTACHMENT = 5,
}

export enum OrderFromContractStepTypeEnum {
  ORDER_DETAILS = 0,
  TRANSPORT = 1,
  DOCUMENTS = 2,
  VERIFY_ORDER = 3,
}
